import { create } from "zustand";
import { aiAgentVoicesInterface, CommonResponseModel, createVoiceAgentPayload, voiceAgentField, voiceAgentListInterface } from "../models/axiosModel";
import agent from "../services/api";
import { initialCreateAgentPayload } from "../components/dashboard/voiceAgent/voiceAgentConstants";


interface voiceAgentStoreInterface {
    voiceAgentList: voiceAgentListInterface[] | null,
    setVoiceAgentList: (value: voiceAgentListInterface[] | null) => void, 

    filteredVoiceAgentList: voiceAgentListInterface[] | null,
    setFilteredVoiceAgentList: (value: voiceAgentListInterface[] | null) => void, 
    
    getVoiceAgentListAPI: () => Promise<CommonResponseModel<voiceAgentListInterface | null>>,

    createAgentPayload: createVoiceAgentPayload,
    setCreateAgentPayload: (value: createVoiceAgentPayload) => void,

    tempCreateAgentPayload: createVoiceAgentPayload,
    setTempCreateAgentPayload: (value: createVoiceAgentPayload) => void,

    voiceAgentDetail: voiceAgentListInterface | null,
    setVoiceAgentDetail: (value: voiceAgentListInterface | null) => void,

    getVoiceAgentDetailAPI: (voice_agent_id: string) => Promise<CommonResponseModel<createVoiceAgentPayload | null>>,

    flagDeleteAgentPopup: boolean,
    setFlagDeleteAgentPopup: (value: boolean) => void,
 
    flagNewDeploymentPopup: boolean,
    setFlagNewDeploymentPopup: (value: boolean) => void,

    deleteVoiceAgentData: voiceAgentListInterface | null,
    setDeleteVoiceAgentData: (value: voiceAgentListInterface | null) => void, 

    aiAgentVoices: aiAgentVoicesInterface[] | null,
    setAIAgentVoices: (value: aiAgentVoicesInterface[] | null) => void, 

    getAIAgentVoicesAPI: () => Promise<CommonResponseModel<aiAgentVoicesInterface[] | null>>,

    voiceAgentFieldData: voiceAgentField[] | null,
    setVoiceAgentFieldData: (value: voiceAgentField[] | null) => void,

    getVoiceAgentFieldAPI: () => Promise<CommonResponseModel<voiceAgentField[] | null>>,
}

export const useVoiceAgentStore = create<voiceAgentStoreInterface>((set) => ({
    voiceAgentList: null,
    setVoiceAgentList: (value) => set({ voiceAgentList: value }), 

    filteredVoiceAgentList: null,
    setFilteredVoiceAgentList: (value) => set({ filteredVoiceAgentList: value }), 

    voiceAgentDetail: null,
    setVoiceAgentDetail: (value) => set({ voiceAgentDetail: value }), 

    createAgentPayload: {
        ...initialCreateAgentPayload,
        voice_agent_detail: {
            ...initialCreateAgentPayload.voice_agent_detail,
        },
        voice_agent_field_data: [],
    } as createVoiceAgentPayload,
    setCreateAgentPayload: (value) => set({ createAgentPayload: value }),

    tempCreateAgentPayload: {
        ...initialCreateAgentPayload,
        voice_agent_detail: {
            ...initialCreateAgentPayload.voice_agent_detail,
        },
        voice_agent_field_data: [],
    } as createVoiceAgentPayload,
    setTempCreateAgentPayload: (value) => set({ tempCreateAgentPayload: value }),

    getVoiceAgentListAPI: async () => {
        const res = await agent.getVoiceAgentList.get();
        if (res.status) {
            set({ voiceAgentList: res?.data })
            set({ filteredVoiceAgentList: res?.data })
        }
        else {
            set({ voiceAgentList: null })
            set({ filteredVoiceAgentList: null })
        }
        return res;
    },

    getVoiceAgentDetailAPI: async (voice_agent_id: string) => {
        const res = await agent.getVoiceAgent.get(voice_agent_id);
        if (res.status) {
            set({ createAgentPayload: res?.data })
            set({ tempCreateAgentPayload: res?.data })
            set({ voiceAgentDetail: res?.data })
        }
        else {
            set({ createAgentPayload: {
                ...initialCreateAgentPayload,
                voice_agent_detail: {
                    ...initialCreateAgentPayload.voice_agent_detail,
                },
                voice_agent_field_data: [],
            }})
            set({ tempCreateAgentPayload: {
                ...initialCreateAgentPayload,
                voice_agent_detail: {
                    ...initialCreateAgentPayload.voice_agent_detail,
                },
                voice_agent_field_data: [],
            }})
            set({ voiceAgentDetail: null })
        }
        return res;
    },

    flagDeleteAgentPopup: false,
    setFlagDeleteAgentPopup: (value: boolean) => set({ flagDeleteAgentPopup: value }),

    flagNewDeploymentPopup: false,
    setFlagNewDeploymentPopup: (value: boolean) => set({ flagNewDeploymentPopup: value }),

    deleteVoiceAgentData: null,
    setDeleteVoiceAgentData: (value) => set({ deleteVoiceAgentData: value }), 

    aiAgentVoices: null,
    setAIAgentVoices: (value) => set({ aiAgentVoices: value }), 

    getAIAgentVoicesAPI: async () => {
        const res = await agent.aiAgentVoice.get();
        if (res.status) {
            set({ aiAgentVoices: res?.data })
        }
        else {
            set({ aiAgentVoices: null })
        }
        return res;
    },

    voiceAgentFieldData: null,
    setVoiceAgentFieldData: (value) => set({ voiceAgentFieldData: value }),

    getVoiceAgentFieldAPI: async () => {
        const res = await agent.getVoiceAgentField.get();
        if (res.status) {
            set({ voiceAgentFieldData: res?.data })
        }
        else {
            set({ voiceAgentFieldData: null })
        }
        return res;
    },
}))